/**
 * Frontend Logger Utility
 * Sends log data to the backend logging API
 */

/**
 * Send log data to the server
 * @param {Object} data - The data to log
 * @param {string} type - Log type (info, error, debug)
 * @returns {Promise} - The fetch promise
 */
export async function serverLog(data, type = 'info') {
    if (!window.jainc || !window.jainc.rest_url || !window.jainc.nonce) {
        console.error('Cannot log to server: missing jainc global object with REST API info');
        return false;
    }
    
    try {
        // Add metadata to the log
        const logData = {
            ...data,
            type,
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        };
        
        // Send to the backend
        const response = await fetch(`${window.jainc.rest_url}jainc/v1/log`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.jainc.nonce
            },
            body: JSON.stringify(logData)
        });
        
        if (!response.ok) {
            throw new Error(`Server logging failed: ${response.status}`);
        }
        
        return true;
    } catch (error) {
        console.error('Error logging to server:', error);
        return false;
    }
}

/**
 * Log info to the server
 * @param {Object} data - Data to log
 */
export function logInfo(data) {
    return serverLog(data, 'info');
}

/**
 * Log error to the server
 * @param {Object} data - Data to log
 */
export function logError(data) {
    return serverLog(data, 'error');
}

/**
 * Log debug information to the server
 * @param {Object} data - Data to log
 */
export function logDebug(data) {
    return serverLog(data, 'debug');
}
